import {
  FDBodyText,
  FDPaper,
  FDStack,
} from '@facet-wealth/design';
import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { dataAttrs } from 'Helpers/Testing';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useMobileLayout from 'Hooks/useMobileLayout';
import { RoadmapExecutiveSummaryNextUpTabs } from './RoadmapExecutiveSummaryNextUpTabs';

export const RoadmapExecutiveSummaryNextUp = ({ ActionsSectionComponent = null, isRoadmapDeliverable = false }) => {
  const { resource } = useMetaLayoutContext();
  const isMobile = useMobileLayout();

  const tabs = resource.attr('tabs')?.resources()?.list() ?? [];
  return (
    <FDPaper appearance={'elevated'} padding={600} {...dataAttrs('roadmap-executive-summary-next-up-section')} width={isMobile || isRoadmapDeliverable ? '100%' : '90%'}>
      <FDStack direction={'column'} spacing={5}>
        <MetaControlField attr={'title'} />
        {tabs.length > 0 ? (
          <RoadmapExecutiveSummaryNextUpTabs tabs={tabs} />
        ) : (
          <FDBodyText value={'No actions over the next 12 months.'} />
        )}
        <FDStack direction={'column'} spacing={4}>
          {ActionsSectionComponent}
        </FDStack>
      </FDStack>
    </FDPaper>
  );
};
